if ($("body.template-content-about").length > 0) {
  const video = document.getElementById("algoras-video");
  const videoProgress = $(".progress .progress-bar");

  const handleProgress = function (e) {
    const percent = (video.currentTime / video.duration) * 100;
    videoProgress.css("width", `${percent}%`);
  };

  video.addEventListener("timeupdate", handleProgress);

  video.addEventListener(
    "play",
    function () {
      $(".play-btn")
        .addClass("active")
        .find(".fas")
        .removeClass("fa-play")
        .addClass("fa-pause");
      $(".video").addClass("in-progress");
    },
    false
  );
  video.addEventListener(
    "pause",
    function () {
      $(".play-btn")
        .removeClass("active")
        .find(".fas")
        .removeClass("fa-pause")
        .addClass("fa-play");
      $(".video").removeClass("in-progress");
    },
    false
  );
  video.addEventListener(
    "ended",
    function () {
      video.load();
    },
    false
  );
  $(".play-btn").on("click", function (e) {
    e.preventDefault();
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
}
